import React, { useState, useMemo, useEffect } from 'react'
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import BigNumber from 'bignumber.js'
import offAlert from "../../../Images/offAlert.png"
import onAlert from "../../../Images/onAlert.png"
import up_down from "../../../Images/up-down.png"
import up from "../../../Images/up.png"
import down from "../../../Images/down.png"
import soundPlay from "../../../Images/sound-play.png"
import { toast } from 'react-toastify';
import Pagination from '../../utils/Pagination/Pagination';
import sound_1 from "../../../Alerts/sound_1.mp3"
import sound_2 from "../../../Alerts/sound_2.mp3"
import sound_3 from "../../../Alerts/sound_3.mp3"
import sound_4 from "../../../Alerts/sound_4.mp3"
import sound_5 from "../../../Alerts/sound_5.mp3"
import sound_6 from "../../../Alerts/sound_6.mp3"
import sound_7 from "../../../Alerts/sound_7.mp3"
import sound_8 from "../../../Alerts/sound_8.mp3"
import sound_9 from "../../../Alerts/sound_9.mp3"
import sound_10 from "../../../Alerts/sound_10.mp3"
import sound_11 from "../../../Alerts/sound_11.mp3"
import sound_12 from "../../../Alerts/sound_12.mp3"

// Number of Rows per Page
const PageSize = 10;

const RowSubscribed = (props) => (
    <React.Fragment>
        <div className="d-none d-sm-inline">
            <div className="row table-row small py-1">
                <div className="col">{props.symbol}</div>
                <div className="col">{props.price}</div>

                <div className={props.usd10s > 0 ? 'col text-success bg-successe' : (props.usd10s < 0 ? 'col text-danger bg-dangere' : 'col')}>{props.usd10s || props.usd10s === 0 ? `${new BigNumber(props.usd10s).toFormat(4,1)} %` : 'loading'}</div>  
                <div className={props.usd20s > 0 ? 'col text-success bg-successe' : (props.usd20s < 0 ? 'col text-danger bg-dangere' : 'col')}>{props.usd20s || props.usd20s === 0 ? `${new BigNumber(props.usd20s).toFormat(4,1)} %` : 'loading'}</div>  
                <div className={props.usd30s > 0 ? 'col text-success bg-successe' : (props.usd30s < 0 ? 'col text-danger bg-dangere' : 'col')}>{props.usd30s || props.usd30s === 0 ? `${new BigNumber(props.usd30s).toFormat(4,1)} %` : 'loading'}</div> 

                <div className={props.usd1min > 0 ? 'col text-success bg-successe' : (props.usd1min < 0 ? 'col text-danger bg-dangere' : 'col')}>{`${new BigNumber(props.usd1min).toFormat(2,1)} %`}</div>
                <div className={props.usd3min > 0 ? 'col text-success bg-successe' : (props.usd3min < 0 ? 'col text-danger bg-dangere' : 'col')}>{`${new BigNumber(props.usd3min).toFormat(2,1)} %`}</div>
                <div className={props.usd5min < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd5min).toFormat(2,1)} %`}</div>  
                
                <div className={props.usd1h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1h).toFormat(2,1)} %`}</div>
                <div className={props.usd2h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd2h).toFormat(2,1)} %`}</div> 
                <div className={props.usd4h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd4h).toFormat(2,1)} %`}</div>
                <div className={props.usd1d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1d).toFormat(2,1)} %`}</div>
                 
                <div className={props.usd7d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd7d).toFormat(2,1)} %`}</div>
                <div className={props.usd30d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd30d).toFormat(2,1)} %`}</div>
                <div className={props.usd1y < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1y).toFormat(2,1)} %`}</div>

            </div>
        </div>
    </React.Fragment> 
)

const RowFree = (props) => (
    <React.Fragment>
        <div className="d-none d-sm-inline">
            <div className="row table-row small py-1">
                <div className="col">{props.symbol}</div>
                <div className="col">{props.price}</div>

                <div className={props.usd1min > 0 ? 'col text-success bg-successe' : (props.usd1min < 0 ? 'col text-danger bg-dangere' : 'col')}>{`${new BigNumber(props.usd1min).toFormat(2,1)} %`}</div>
                <div className={props.usd3min > 0 ? 'col text-success bg-successe' : (props.usd3min < 0 ? 'col text-danger bg-dangere' : 'col')}>{`${new BigNumber(props.usd3min).toFormat(2,1)} %`}</div>
                <div className={props.usd5min < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd5min).toFormat(2,1)} %`}</div>  
                
                <div className={props.usd1h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1h).toFormat(2,1)} %`}</div>
                <div className={props.usd2h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd2h).toFormat(2,1)} %`}</div> 
                <div className={props.usd4h < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd4h).toFormat(2,1)} %`}</div>
                <div className={props.usd1d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1d).toFormat(2,1)} %`}</div>
                 
                <div className={props.usd7d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd7d).toFormat(2,1)} %`}</div>
                <div className={props.usd30d < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd30d).toFormat(2,1)} %`}</div>
                <div className={props.usd1y < 0 ? 'col text-danger bg-dangere' : 'col text-success bg-successe'}>{`${new BigNumber(props.usd1y).toFormat(2,1)} %`}</div>

            </div>
        </div>
    </React.Fragment> 
)

const DataTable = ({percentages, subscribed, alert, setAlert, searchText}) => {

    const [AlertFile, setAlertFile] = useState(sound_1)

    let audioAlert1 = useMemo(() => new Audio(sound_1), [AlertFile]);
    let audioAlert2 = useMemo(() => new Audio(sound_2), [AlertFile]);
    let audioAlert3 = useMemo(() => new Audio(sound_3), [AlertFile]);
    let audioAlert4 = useMemo(() => new Audio(sound_4), [AlertFile]);
    let audioAlert5 = useMemo(() => new Audio(sound_5), [AlertFile]);
    let audioAlert6 = useMemo(() => new Audio(sound_6), [AlertFile]);
    let audioAlert7 = useMemo(() => new Audio(sound_7), [AlertFile]);
    let audioAlert8 = useMemo(() => new Audio(sound_8), [AlertFile]);
    let audioAlert9 = useMemo(() => new Audio(sound_9), [AlertFile]);
    let audioAlert10 = useMemo(() => new Audio(sound_10), [AlertFile]);
    let audioAlert11 = useMemo(() => new Audio(sound_11), [AlertFile]);
    let audioAlert12 = useMemo(() => new Audio(sound_12), [AlertFile]);

    const [alertData, setAlertData] = useState({ column:"", gt:"", lt: "", sound:"", emailNotif: "" })

    const [activeSort, setActiveSort] = useState({ column:"", type:""})
 

    let Alert = (localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {})
    let searchedArray = []

    useEffect(() => {
        // Initialize the Active Alert
        let keys = Object.keys(Alert);
        for(let i=0; i<keys.length;i++){
            setAlert(prevState => { return {...prevState, [keys[i]]:true}})
        }  
    }, [])

    const handlePlaySound = async () => {
        switch(alertData.sound){
            case "sound_1":
                audioAlert1.play()
                break;
            case "sound_2":
                audioAlert2.play()
                break;
            case "sound_3":
                audioAlert3.play()
                break;
            case "sound_4":
                audioAlert4.play()
                break;
            case "sound_5":
                audioAlert5.play()
                break;
            case "sound_6":
                audioAlert6.play()
                break;
            case "sound_7":
                audioAlert7.play()
                break;
            case "sound_8":
                audioAlert8.play()
                break;
            case "sound_9":
                audioAlert9.play()
                break;
            case "sound_10":
                audioAlert10.play()
                break;
            case "sound_11":
                audioAlert11.play()
                break;
            case "sound_12":
                audioAlert12.play()
                break;
            default:
                audioAlert1.play()
                break;
        }
    }

    const handleSort = (e) => {
        let {id} = e.target
        if(activeSort.column === id && activeSort.type === 'up'){
            setActiveSort({'column':id, 'type':'down'})
        }else if(activeSort.column === id && activeSort.type === 'down'){
            setActiveSort({'column':'', 'type':''})
        }else{
            setActiveSort({'column':id, 'type':'up'})
        }
    };
    
    // Open Alert Modal
    const handleChange = (e) => {
        const { id, value } = e.target
        setAlertData({ ...alertData, [id]: value })
    }

    const handleCheckBox = (e) => {
        const { id, checked } = e.target
        setAlertData({ ...alertData, emailNotif: checked })
    }

    // Close Alert Modal
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState("");

    const handleClose = () => {
        setShow(false);
        setOpen("");
    }

    // Open Alert Modal
    const handleShow = (e) => {
        let column = e.target.id;
        let Alert = (localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {})
        if(Alert[column]){
            setAlertData(Alert[column])
        }else{
            setAlertData({...alertData, gt:"", lt: "", sound:"", emailNotif: ""})
        }

        setOpen(column)
        setShow(true)
    };

    // Disable an Alert
    const handleDisableAlert = (e) => {
        if(alert[open]){
            // Turn off the Alert and change the session
            let newAlert = JSON.parse(localStorage.getItem('dataAlert'))
            delete newAlert[open]
            localStorage.setItem('dataAlert', JSON.stringify(newAlert));
            handleClose()
            setAlertData({column:"", gt:"", lt: "", sound:"", emailNotif: ""})
            setAlert({...alert, [open]:false})
        }
    };

    // Saving the Alert in the session When changing the Parameters 
    const handleAlertSubmit = () => {
        if(alertData.gt === '' && alertData.lt === '' ){
            toast.error('Cannot submit empty values', { containerId:'DisplayInfo', theme: "colored" })
        }else{
            setAlert({...alert, [open]:true})
            setAlertData({...alertData, column:open})
            handleClose()
        }
    }

    useEffect(() => {
        let Alert = (localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {})
        if(alertData.column !== ''){
            alertData.gt = alertData.gt === '' ? 100 : alertData.gt 
            alertData.lt = alertData.lt === '' ? -100 : alertData.lt 
            Alert[alertData.column] = alertData
            localStorage.setItem('dataAlert', JSON.stringify(Alert));
            setAlertData({ column:"", gt:"", lt: "", sound:"", emailNotif: "" })
        }
        
    }, [alert])

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    let firstPageIndex = (currentPage - 1) * PageSize;
    let lastPageIndex = firstPageIndex + PageSize;

    useMemo(() => {
      firstPageIndex = (currentPage - 1) * PageSize;
      lastPageIndex = firstPageIndex + PageSize;
    }, [currentPage]);


    const ShowRowsForSubscribed = (data, rows) => {
        data.slice(firstPageIndex, lastPageIndex).map(({ symbol_name, symbol, price, usd10s, usd20s, usd30s, usd1min, usd3min, usd5min, usd1h, usd2h, usd4h, usd1d, usd7d, usd30d, usd1y }, index) => (
        rows.push(
            <RowSubscribed key={index} symbol_name={symbol_name} symbol={symbol} price={BigNumber(price) < 1 ? new BigNumber(price).toFormat(6,1) : new BigNumber(price).toFormat(3,1)} 
            usd10s={usd10s*100} usd20s={usd20s*100} usd30s={usd30s*100} usd1min={usd1min*100} usd3min={usd3min*100} usd5min={usd5min*100} usd1h={usd1h*100} usd2h={usd2h*100}
            usd4h={usd4h*100} usd1d={usd1d*100} usd7d={usd7d*100} usd30d={usd30d*100} usd1y={usd1y*100}/>
        )))
    }

    const ShowRowsFree = (data, rows) => {
        data.slice(firstPageIndex, lastPageIndex).map(({ symbol_name, symbol, price, usd1min, usd3min, usd5min, usd1h, usd2h, usd4h, usd1d, usd7d, usd30d, usd1y }, index) => (
        rows.push(
            <RowFree key={index} symbol_name={symbol_name} symbol={symbol} price={BigNumber(price) < 1 ? new BigNumber(price).toFormat(6,1) : new BigNumber(price).toFormat(3,1)} 
            usd1min={usd1min*100} usd3min={usd3min*100} usd5min={usd5min*100} usd1h={usd1h*100} usd2h={usd2h*100}
            usd4h={usd4h*100} usd1d={usd1d*100} usd7d={usd7d*100} usd30d={usd30d*100} usd1y={usd1y*100}/>
        )))
    }

    // Show Rows
    let rows = [];

    // No Searching
    if(searchText === ""){
        // no Sorting
        if(activeSort.column === ''){
            subscribed ? ShowRowsForSubscribed(percentages,rows) : ShowRowsFree(percentages,rows)
        }else{
            // get the sorted columns
            let column = 'usd' + activeSort.column.slice(3)
            let SortData = [...percentages]
            if(activeSort.type === 'up'){
                SortData.sort((a, b) => {
                    return a[column] - b[column];
                });
            }else{
                SortData.sort((a, b) => {
                    return b[column] - a[column];
                });
            }
            subscribed ? ShowRowsForSubscribed(SortData,rows) : ShowRowsFree(SortData,rows)
        }
        
    }else{
        searchedArray = percentages.filter(function( obj ) {
            return obj.symbol.startsWith(searchText.toUpperCase());
        });
        subscribed ? ShowRowsForSubscribed(searchedArray,rows) : ShowRowsFree(searchedArray,rows)
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [searchText])
    
    return (
        subscribed ?
        <React.Fragment>
            {/* ALERT MODAL */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>ALERT :</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="inputGroup-sizing-default">Rate &gt;=</InputGroup.Text>
                            <Form.Control type="number" placeholder="2.5 %" autoFocus aria-label="Default"
                            aria-describedby="inputGroup-sizing-default" id="gt" value={alertData.gt} onChange={handleChange}/>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="inputGroup-sizing-default">Rate &lt;=</InputGroup.Text>
                            <Form.Control type="number" placeholder="-1.7 %" aria-label="Default"
                            aria-describedby="inputGroup-sizing-default" id="lt" value={alertData.lt} onChange={handleChange}/>
                        </InputGroup>
                        <div className='d-flex justify-content-start mb-3 align-items-center'>
                            <Form.Select id="sound" className='mr-3' onChange={handleChange}>
                                <option>Sound Alert</option>
                                <option value="sound_1" selected={alertData.sound === "sound_1"}>sound_1</option>
                                <option value="sound_2" selected={alertData.sound === "sound_2"}>sound_2</option>
                                <option value="sound_3" selected={alertData.sound === "sound_3"}>sound_3</option>
                                <option value="sound_4" selected={alertData.sound === "sound_4"}>sound_4</option>
                                <option value="sound_5" selected={alertData.sound === "sound_5"}>sound_5</option>
                                <option value="sound_6" selected={alertData.sound === "sound_6"}>sound_6</option>
                                <option value="sound_7" selected={alertData.sound === "sound_7"}>sound_7</option>
                                <option value="sound_8" selected={alertData.sound === "sound_8"}>sound_8</option>
                                <option value="sound_9" selected={alertData.sound === "sound_9"}>sound_9</option>
                                <option value="sound_10" selected={alertData.sound === "sound_10"}>sound_10</option>
                                <option value="sound_11" selected={alertData.sound === "sound_11"}>sound_11</option>
                                <option value="sound_12" selected={alertData.sound === "sound_12"}>sound_12</option>
                            </Form.Select>
                            <button type='button' onClick={handlePlaySound} class="btn btn-primary play-btn">
                                <img alt="playsound" src={soundPlay}/>
                            </button>
                        </div>
                        <Form.Check className="mt-3" inline type="switch" id="emailNotif" label="  E-mail Alert?" 
                        onChange={handleCheckBox} checked={alertData.emailNotif === true}/>
                    </Form>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <Button onClick={handleDisableAlert} size="sm" variant="danger">Disable</Button>
                    <Button variant="primary" onClick={handleAlertSubmit}>Apply Alert</Button>
                </Modal.Footer>
            </Modal>

            {/* COLUMNS */}
            <div className="d-none d-sm-inline DataTable">
                <div className="row table-header small font-weight-bold py-1">
                    <div className="col"></div>
                    <div className="col"></div>
                    <div className="col"><img alt="alert" className='Alert-img' id='c10s' onClick={handleShow} src={alert.c10s === true ? onAlert : offAlert}/></div>
                    <div className="col"><img alt="alert" className='Alert-img' id='c20s' onClick={handleShow} src={alert.c20s === true ? onAlert : offAlert}/></div>
                    <div className="col"><img alt="alert" className='Alert-img' id='c30s' onClick={handleShow} src={alert.c30s === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1m' onClick={handleShow} src={alert.c1m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c3m' onClick={handleShow} src={alert.c3m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c5m' onClick={handleShow} src={alert.c5m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1h' onClick={handleShow} src={alert.c1h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c2h' onClick={handleShow} src={alert.c2h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c4h' onClick={handleShow} src={alert.c4h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1d' onClick={handleShow} src={alert.c1d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c7d' onClick={handleShow} src={alert.c7d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c30d' onClick={handleShow} src={alert.c30d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1y' onClick={handleShow} src={alert.c1y === true ? onAlert : offAlert} /></div>
                </div>
            </div>
            <div className="d-none d-sm-inline DataTable">
                <div className="row table-header small font-weight-bold py-1">
                    <div className="col">Name</div>
                    <div className="col">Last Price</div>
                    <div className="col">10s</div>
                    <div className="col">20s</div>
                    <div className="col">30s</div>
                    <div className="col up-down" id='per1min' onClick={handleSort}>1m<img alt="sort" src={activeSort.column === 'per1min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per3min' onClick={handleSort}>3m<img alt="sort" src={activeSort.column === 'per3min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per5min' onClick={handleSort}>5m<img alt="sort" src={activeSort.column === 'per5min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1h' onClick={handleSort}>1h<img alt="sort" src={activeSort.column === 'per1h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per2h' onClick={handleSort}>2h<img alt="sort" src={activeSort.column === 'per2h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per4h' onClick={handleSort}>4h<img alt="sort" src={activeSort.column === 'per4h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1d' onClick={handleSort}>1 Day<img alt="sort" src={activeSort.column === 'per1d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per7d' onClick={handleSort}>1 Week<img alt="sort" src={activeSort.column === 'per7d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per30d' onClick={handleSort}>30 Days<img alt="sort" src={activeSort.column === 'per30d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1y' onClick={handleSort}>1 Year<img alt="sort" src={activeSort.column === 'per1y' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                </div>
            </div>
            
            {/* ROWS */}
            <div className='rows-container'>
                {rows}
            </div>

            {/* PAGINATION */}
            <Pagination currentPage={currentPage} totalCount={searchText === "" ? percentages.length : searchedArray.length} pageSize={PageSize} 
            onPageChange={page => setCurrentPage(page)}/>
        </React.Fragment>
        :
        <React.Fragment>
            {/* ALERT MODAL */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>ALERT :</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="inputGroup-sizing-default">Rate &gt;=</InputGroup.Text>
                            <Form.Control type="number" placeholder="2.5 %" autoFocus aria-label="Default"
                            aria-describedby="inputGroup-sizing-default" id="gt" value={alertData.gt} onChange={handleChange}/>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="inputGroup-sizing-default">Rate &lt;=</InputGroup.Text>
                            <Form.Control type="number" placeholder="-1.7 %" aria-label="Default"
                            aria-describedby="inputGroup-sizing-default" id="lt" value={alertData.lt} onChange={handleChange}/>
                        </InputGroup>
                        <div className='d-flex justify-content-start mb-3 align-items-center'>
                            <Form.Select id="sound" className='mr-3' onChange={handleChange}>
                                <option>Sound Alert</option>
                                <option value="sound_1" selected={alertData.sound === "sound_1"}>sound_1</option>
                                <option value="sound_2" selected={alertData.sound === "sound_2"}>sound_2</option>
                                <option value="sound_3" selected={alertData.sound === "sound_3"}>sound_3</option>
                                <option value="sound_4" selected={alertData.sound === "sound_4"}>sound_4</option>
                                <option value="sound_5" selected={alertData.sound === "sound_5"}>sound_5</option>
                                <option value="sound_6" selected={alertData.sound === "sound_6"}>sound_6</option>
                                <option value="sound_7" selected={alertData.sound === "sound_7"}>sound_7</option>
                                <option value="sound_8" selected={alertData.sound === "sound_8"}>sound_8</option>
                                <option value="sound_9" selected={alertData.sound === "sound_9"}>sound_9</option>
                                <option value="sound_10" selected={alertData.sound === "sound_10"}>sound_10</option>
                                <option value="sound_11" selected={alertData.sound === "sound_11"}>sound_11</option>
                                <option value="sound_12" selected={alertData.sound === "sound_12"}>sound_12</option>
                            </Form.Select>
                            <button type='button' onClick={handlePlaySound} class="btn btn-primary play-btn">
                                <img alt="playsound" src={soundPlay}/>
                            </button>
                        </div>
                    </Form>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <Button onClick={handleDisableAlert} size="sm" variant="danger">Disable</Button>
                    <Button variant="primary" onClick={handleAlertSubmit}>Apply Alert</Button>
                </Modal.Footer>
            </Modal>

            {/* COLUMNS */}
            <div className="d-none d-sm-inline DataTable">
                <div className="row table-header small font-weight-bold py-1">
                    <div className="col"></div>
                    <div className="col"></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1m' onClick={handleShow} src={alert.c1m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c3m' onClick={handleShow} src={alert.c3m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c5m' onClick={handleShow} src={alert.c5m === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1h' onClick={handleShow} src={alert.c1h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c2h' onClick={handleShow} src={alert.c2h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c4h' onClick={handleShow} src={alert.c4h === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1d' onClick={handleShow} src={alert.c1d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c7d' onClick={handleShow} src={alert.c7d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c30d' onClick={handleShow} src={alert.c30d === true ? onAlert : offAlert}/></div>
                    <div className="col" ><img alt="alert" className='Alert-img' id='c1y' onClick={handleShow} src={alert.c1y === true ? onAlert : offAlert} /></div>
                </div>
            </div>
            <div className="d-none d-sm-inline DataTable">
                <div className="row table-header small font-weight-bold py-1">
                    <div className="col">Name</div>
                    <div className="col">Last Price</div>
                    <div className="col up-down" id='per1min' onClick={handleSort}>1m<img alt="sort" src={activeSort.column === 'per1min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per3min' onClick={handleSort}>3m<img alt="sort" src={activeSort.column === 'per3min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per5min' onClick={handleSort}>5m<img alt="sort" src={activeSort.column === 'per5min' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1h' onClick={handleSort}>1h<img alt="sort" src={activeSort.column === 'per1h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per2h' onClick={handleSort}>2h<img alt="sort" src={activeSort.column === 'per2h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per4h' onClick={handleSort}>4h<img alt="sort" src={activeSort.column === 'per4h' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1d' onClick={handleSort}>1 Day<img alt="sort" src={activeSort.column === 'per1d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per7d' onClick={handleSort}>1 Week<img alt="sort" src={activeSort.column === 'per7d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per30d' onClick={handleSort}>30 Days<img alt="sort" src={activeSort.column === 'per30d' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                    <div className="col up-down" id='per1y' onClick={handleSort}>1 Year<img alt="sort" src={activeSort.column === 'per1y' ? (activeSort.type === 'up' ? up : down) : up_down}/></div>
                </div>
            </div>
            
            {/* ROWS */}
            <div className='rows-container'>
                {rows}
            </div>

            {/* PAGINATION */}
            <Pagination currentPage={currentPage} totalCount={searchText === "" ? percentages.length : searchedArray.length} pageSize={PageSize} 
            onPageChange={page => setCurrentPage(page)}/>
        </React.Fragment>

    );
}

export default DataTable;